import React, { useState } from "react";
import less from "./customerSeats.module.scss";
import BottomUpSheet from "./BottomUpSheet";
import FullScreenTnc from "./FullScreenTnc";
import mixpanel from "mixpanel-browser";
import moment from "moment";
import { mixPanelToken, isStage } from "../../config";

const FoodOrderBanner = ({
  mealsDetails,
  onFoodOrderCancel,
  orderFood,
  booking
}) => {
  const showBanner =
    mealsDetails &&
    mealsDetails.orderedFoodItemsDetails &&
    mealsDetails.orderedFoodItemsDetails.length > 0;

  const showOrderBanner = mealsDetails && mealsDetails.canOrderFood;

  const isCancelled = mealsDetails && mealsDetails.status === "CANCELLED";

  const [isFoodModalOpen, setOpen] = useState(false);
  const [showTnc, setShowTnc] = useState(false);

  if (!showBanner && !showOrderBanner) return null;

  const handleTncClicked = () => {
    setShowTnc(true);
    setOpen(false);
  };

  const addFoodOrderedEvent = () => {
    mixpanel.init(mixPanelToken, { debug: isStage });

    let track = "View Food Details Banner Clicked";
    mixpanel.track(track, {
      view_from: "Self Help Page",
      demand_source: booking.demandSource,
      service_name: booking.trip.service.name,
      trip_date: moment(booking.boardingPoint.time).format("DD-MM-YYYY"),
      pnr: booking.bookingCode,
      no_food_items: mealsDetails.orderedFoodItemsDetails.length,
      food_items_cost: mealsDetails.priceDetails.cost
    });
  };

  if (showOrderBanner) {
    return (
      <div
        className={less.banner_order}
        onClick={() => {
          orderFood();
        }}
      >
        <img
          src="https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/food/banner_1782459014062.webp"
          alt="order-food"
        />
        <div>
          <div className={less.order_text}>
            <span className={less.order_title}>Don’t Travel Hungry!</span>
            <span>Fresh meals from trusted outlets, served right on time.</span>
          </div>

          <button className={less.order_btn}>Order Now</button>
        </div>
      </div>
    );
  }

  return (
    <>
      <BottomUpSheet
        isOpen={isFoodModalOpen}
        onClose={() => setOpen(false)}
        mealsDetails={mealsDetails}
        onTncClick={handleTncClicked}
        onCancelClick={onFoodOrderCancel}
        isCancelled={isCancelled}
      />

      {showTnc && <FullScreenTnc onClose={() => setShowTnc(false)} />}

      {isCancelled ? (
        <div
          className={less.banner_cancelled}
          onClick={() => {
            setOpen(true);
            addFoodOrderedEvent();
          }}
        >
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/FOB/cancelled.svg"
            alt="cancelled"
          />
          <div>
            <p>Order Cancelled Successfully</p>
            <span>Tap to view details of your cancelled order.</span>
          </div>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/FOB/leftArrow.svg"
            alt="arrow-left"
          />
        </div>
      ) : (
        <div
          className={less.banner_confirmed}
          onClick={() => {
            setOpen(true);
            addFoodOrderedEvent();
          }}
        >
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/FOB/confirmed.svg"
            alt="confirmed"
          />
          <div>
            <p>Your Food Order is Confirmed 🎉</p>
            <span>
              We’ll hand it over to you on the bus, fresh and on time.
            </span>
          </div>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/FOB/leftArrow.svg"
            alt="arrow-left"
          />
        </div>
      )}
    </>
  );
};

export default FoodOrderBanner;
